// Sinal global entre o toast de notificação de duelo (montado no layout, fora
// da árvore da página de Duelos) e a página de Duelos: dispara sempre que o
// card de notificação fecha — aceitar, recusar, ignorar (expirar) ou fechar no X —
// pra quem estiver com a listagem de duelos aberta atualizar sem precisar recarregar.
export const DUEL_NOTIFICATION_CLOSED_EVENT = 'duel-notification-closed';

export function emitDuelNotificationClosed() {
  window.dispatchEvent(new Event(DUEL_NOTIFICATION_CLOSED_EVENT));
}
